import { createAction } from 'redux-actions';

import { openFailedAlert } from 'actions/alert';

import { getCoLiving } from 'actions/coLiving';
import { wrapFetch } from 'actions/endpoint';

export const getBanner = createAction('FETCH_BANNER', () => async dispatch => {
	const { status, message, data: { banner, lifestyle } } = await wrapFetch('banner', {
		method: 'GET',
	});

	if (status !== 200) {
		throw openFailedAlert('generic', message);
	}

	dispatch(getCoLiving(lifestyle));

	return {
		id: banner.id,
		subTitle: banner.subtitle,
		title: banner.title,
		url: banner.url_url,
		createdAt: banner.created_at,
		updatedAt: banner.updated_at,
	};
});



// WEBPACK FOOTER //
// ./src/actions/banner.js